export function isDesktopDevice() {
  if (!window) {
    return false
  }
  return window.innerWidth > 1024
}
